import { existsFilter } from '@iotv/core-services';
import { SupportedPayloadDefinitions } from '@iotv/lfc-devices';
import { resolvePayloadDefinitions } from '@iotv/payload-definition';
export const getDownlinkDefinitionAttributes = ({ device }) => {
    let downLinkPayloadAttributes = undefined;
    let downLinkRangeLimits = undefined;
    let payloadDefintionNames = undefined;
    let correspondingUplinkAttributeMap = null;
    if (device) {
        const resolved = resolvePayloadDefinitions({ rawPayloadStr: undefined, device, port: null });
        payloadDefintionNames = resolved.map((def) => def.name).filter(existsFilter);
        const downlink = resolved[0]?.downlink;
        if (downlink) {
            downLinkPayloadAttributes = downlink.downLinkPayloadAttributes;
            downLinkRangeLimits = downlink.downLinkRangeLimits;
            correspondingUplinkAttributeMap = downlink.correspondingUplinkAttributeMap;
        }
        console.log(`Resolved:`, { payloadDefintionNames, downLinkPayloadAttributes, downLinkRangeLimits, correspondingUplinkAttributeMap });
    }
    const { appCycleTime: _appCycleTime, sysCycleTime: _sysCycleTime, randomizationFactor: _randomizationFactor, adr: _adr, dr: _dr, restoreDefaults: _restoreDefaults, reboot: _reboot, ...attributes } = downLinkPayloadAttributes ??
        SupportedPayloadDefinitions.GenericDevicePayloadDefinition.downlink.downLinkPayloadAttributes;
    const rangeLimits = downLinkRangeLimits ?? SupportedPayloadDefinitions.GenericDevicePayloadDefinition.downlink.downLinkRangeLimits;
    return { attributes, rangeLimits, payloadDefintionNames, correspondingUplinkAttributeMap };
};
